import {Vue} from "ui.vue"
import './css/available.css'

export let SortList = {
	name: 'SortList',
	store: BX.Citrus.Vuex.store,
	data: function() {
		return {
			showBlock: true,
			selected: false,
			options: [],
			arSort: []
		};
	},
	computed: {
		loc: () => Object.freeze(Vue.getFilteredPhrases("CATALOG_SORT_VIEW_")),
		view: function () {
			return this.$store.getters['settings/viewGrid'];
		},
		productCount: function () {
			return this.$store.getters['settings/pageCount'];
		},
		available() {
			return this.$store.getters['settings/available'];
		}
	},
	created: function() {
		this.$store.dispatch('settings/load');

		for(let arItem of this.arSort)
		{
			this.options.push({
				name: arItem.CODE,
				title: arItem.NAME
			});
		}

		let selected = this.arSort.filter((arItem) => arItem.SELECTED);
		if(selected.length > 0) {
			this.selected = {
				name: selected[0].CODE,
				title: selected[0].NAME
			};
		}

		Vue.event.$emit('Citrus.Vue.Grid:refresh');

		BX.addCustomEvent('Citrus.Vue.Grid:init', this.gridInit);
	},
	beforeDestroy: function () {

	},
	methods: {
		gridInit: function(list)
		{
			if(false === list)
			{
				this.showBlock = false;
			}
		},
		changeView: function(view) {
			this.$store.dispatch('settings/setViewGrid', view);

			BX.onCustomEvent('Citrus.Vue.Grid:setViewGrid',[{viewGrid:view}]);
		},
		setSorting: function(option) {
			this.$store.dispatch('settings/setSortGrid', option.name);
			setTimeout(() => {
				window.location.reload();
			}, 100);
		},
		changeAvailable() {
			this.$store.dispatch('settings/setAvailable', !this.available);
			setTimeout(() => {
				window.location.reload();
			}, 100);
		}
	}
};

export default {SortList};
